export const copyFormat = (quill, copyFormatting, callback) => {
  // 点击格式刷，如果有选中区域且有样式，则保存其样式，按键状态改为选中。
// 再次点击，删除样式，按键取消选中。
  if (copyFormatting.value) {
    let range = quill.getSelection(true)
    console.log(range)
    if (range == null || range.length === 0) {
      copyFormatting.type = false
      callback()
      return
    }
    range.length = 1
    let format = quill.getFormat(range)
    console.log(range, format)
    // if (Object.keys(format).length === 0) return // format为{}，表示无样式也要处理
    setCopyFormatting(quill, copyFormatting, false, format, callback)
  } else {
    setCopyFormatting(quill, copyFormatting, true, null, callback)
  }
}
// 设置copyFormatting: 修改保存的样式、按键状态、粘贴样式的处理程序
export const setCopyFormatting = (quill, copyFormatting, value, format, callback) => {
  copyFormatting.value = value
  copyFormatting.format = format
  if (!value) {
    quill.on('selection-change', pasteFormatHandler)
  } else {
    quill.off('selection-change', pasteFormatHandler)
  }
  function pasteFormatHandler (range, oldRange, source) {
    return pasteFormat(range, oldRange, source, quill, copyFormatting, callback)
  }
}
// 粘贴样式的处理程序: 如果选中范围且有保存样式，则粘贴样式，并初始化copyFormatting
export const pasteFormat = (range, oldRange, source, quill, copyFormatting, callback) => {
  if (range && copyFormatting.format) {
    if (range.length === 0) {
    } else {
      // 清空当前选中样式
      quill.removeFormat(range.index, range.length)
      // 设置格式刷选中样式
      quill.formatText(range.index, range.length, copyFormatting.format)
      setCopyFormatting(quill, copyFormatting, true, null)
      copyFormatting.type = false
      callback()
    }
  } else {
    // console.log('Cursor not in the editor')
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-editor-new/blot/format-painter.js